/* eslint-disable dr-domain-words/no-domain-words -- Stored colour names from before the neutral palette (plan §9.1, §7.6): read-time aliases until wave 3, when quality-gates deletes this module. */
/**
 * Object colour names that were stored before the neutral palette (wave 2, plan §9.1). Each maps to
 * the neutral colour with the same hue, so an object keeps its visible colour (companies were blue,
 * people orange, activities violet, …). Blueprint packages on disk still use these names until
 * demo-showcase rewrites them in wave 3; the data migration `design-system-object-colours` rewrites
 * stored colours (and the blueprint ledger's base specs, so installed objects stay "managed").
 * Nothing new may use these names.
 *
 * Owner: design-system (wave 2). Deleted by quality-gates in wave 3 together with the aliases.
 */
export const LEGACY_OBJECT_COLORS = {
  companies: 'blue',
  people: 'orange',
  deals: 'green',
  activities: 'violet',
  projects: 'teal',
  candidates: 'rose',
  other: 'slate',
} as const;

export type LegacyObjectColor = keyof typeof LEGACY_OBJECT_COLORS;

export const LEGACY_OBJECT_COLOR_NAMES = Object.keys(LEGACY_OBJECT_COLORS) as LegacyObjectColor[];
